"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const react_hanger_1 = require("react-hanger");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const react_router_dom_1 = require("react-router-dom");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const ResourceSelector_1 = require("./ResourceSelector");
const react_2 = require("@osmosys/react");
const CheckIcon_1 = require("../../../../comps/reusables/CheckIcon");
const ResourceListTable_1 = require("../ResourceListTable");
// : FC <>
const AddUserModal = react_router_dom_1.withRouter(({ isOpen, onClose, history }) => {
    const fullName = react_hanger_1.useInput('');
    const email = react_hanger_1.useInput('');
    const [workspaces, setWorkspaces] = react_1.default.useState([]);
    const [newUserId, setUserId] = react_1.default.useState(null);
    // Redirect when mutation was successful
    react_1.default.useEffect(() => {
        let t;
        if (!isNaN(newUserId) && newUserId !== null) {
            t = setTimeout(() => {
                history.push(`/admin/users/${newUserId}`);
            }, 2 * 1000);
        }
        return () => {
            clearTimeout(t);
        };
    }, [history, newUserId]);
    return (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.createUser, variables: {
            data: {
                email: email.value,
                fullName: fullName.value,
                workspaces: (workspaces || []).map(w => w.id),
            },
        }, onCompleted: ({ createUser }) => {
            setUserId(createUser.id);
        } }, (save, mutationResult) => {
        const disabled = !!(newUserId || mutationResult.loading);
        return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "UsersList", isOpen: isOpen, centered: true, toggle: () => onClose() },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => onClose() }, newUserId ? 'Redirecting...' : 'Add new user'),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement(reactstrap_1.FormGroup, null,
                    react_1.default.createElement(reactstrap_1.Label, null, "Name"),
                    react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "text", placeholder: "Name" }, fullName.eventBind, { disabled: disabled }))),
                react_1.default.createElement(reactstrap_1.FormGroup, null,
                    react_1.default.createElement(reactstrap_1.Label, null, "Email"),
                    react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "email", placeholder: "Email" }, email.eventBind, { disabled: disabled }))),
                react_1.default.createElement(ResourceSelector_1.ResourceSelector, { resource: "workspace", value: workspaces, isMulti: true, onChange: val => {
                        setWorkspaces(val);
                    } }),
                react_1.default.createElement(reusables_1.AjaxButton, { label: newUserId ? 'Redirecting...' : 'Create user', onClick: () => {
                        save();
                    }, color: "success", error: mutationResult.error, success: !!mutationResult.data, loading: mutationResult.loading, disabled: disabled }),
                react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: mutationResult.error, resource: "User", action: "create" }))));
    }));
});
exports.UsersList = () => {
    const [showAddUserModal, toggleAddWorkspaceMembershipModal] = react_use_1.useToggle(false);
    return (react_1.default.createElement(ResourceListTable_1.ResourceListTable, { variables: () => {
            return {};
        }, cells: user => {
            return [
                react_1.default.createElement("span", { className: react_2.classnames('font-weight-bold'), key: 1 },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/memberships/${user.id}` }, user.id)),
                react_1.default.createElement("span", { key: 2, className: react_2.classnames('font-weight-bold', !user.fullName && 'text-muted') },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/users/${user.id}` }, user.fullName || `User #${user.id}`)),
                react_1.default.createElement("span", { key: 3, className: react_2.classnames(!user.email && 'text-muted') }, user.email || 'No email'),
                react_1.default.createElement(react_moment_1.default, { key: 4, format: "lll", className: "font-weight-light" }, user.createdAt),
                react_1.default.createElement(react_moment_1.default, { key: 5, format: "lll", className: "font-weight-light" }, user.updatedAt),
                react_1.default.createElement(CheckIcon_1.CheckIcon, { key: 6, checked: user.isAppAdmin }),
                react_1.default.createElement(CheckIcon_1.CheckIcon, { key: 7, checked: user.hasPassword }),
            ];
        }, filters: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Button, { color: "success", size: "sm", className: "ml-2", onClick: () => {
                    toggleAddWorkspaceMembershipModal();
                } }, "Add user"),
            react_1.default.createElement(AddUserModal, { isOpen: showAddUserModal, onClose: () => {
                    toggleAddWorkspaceMembershipModal(false);
                } })), headers: [
            {
                direction: 'ASC',
                label: 'ID',
                name: 'id',
                width: 5,
            },
            {
                direction: 'ASC',
                label: 'Name',
                name: 'name',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Email',
                name: 'email',
                width: 30,
            },
            {
                direction: 'ASC',
                label: 'Created',
                name: 'createdAt',
                width: 15,
            },
            {
                direction: 'ASC',
                label: 'Updated',
                name: 'updatedAt',
                width: 15,
            },
            {
                direction: 'ASC',
                label: 'App admin',
                name: 'active',
                width: 10,
            },
            {
                direction: 'ASC',
                label: 'Has password',
                name: 'admin',
                width: 10,
            },
        ], query: graphql_1.users, keys: {
            count: 'usersCount',
            item: 'users',
        }, singular: "user", plural: "users" }));
    // return (
    //   <ResourceListTable<
    //     IFilterData,
    //     {
    //       users: User[];
    //     },
    //     {},
    //     User
    //   >
    //     variables={context => {
    //       return {
    //         isAppAdmin:
    //           context.state.isAppAdmin === 'all'
    //             ? undefined
    //             : context.state.isAppAdmin === 'showAdmins'
    //             ? true
    //             : context.state.isAppAdmin === 'hideAdmins'
    //             ? false
    //             : undefined,
    //         searchQuery: context.state.searchQuery,
    //       };
    //     }}
    //     cells={userData => {
    //       return [
    //         <span
    //           className={classnames(
    //             'font-weight-bold',
    //             !userData.fullName && 'text-muted'
    //           )}
    //           key={1}
    //         >
    //           <Link className="text-reset" to={`/admin/users/${userData.id}`}>
    //             {userData.fullName || `User #${userData.id}`}
    //           </Link>
    //         </span>,
    //         userData.email,
    //         // <span
    //         //   className={classnames(
    //         //     'font-weight-bold',
    //         //     !userData.fullName && 'text-muted'
    //         //   )}
    //         // >
    //         //   {(userData.workspaceMemberships || []).map(user => {
    //         //     return (
    //         //       <Link
    //         //         className="text-reset"
    //         //         to={`/admin/workspaces/${user.workspace.id}`}
    //         //       >
    //         //         {user.workspace.name}
    //         //       </Link>
    //         //     );
    //         //   })}
    //         // </span>,
    //         <Moment key={2} format="lll" className="font-weight-light">
    //           {userData.createdAt}
    //         </Moment>,
    //         <Moment key={3} format="lll" className="font-weight-light">
    //           {userData.updatedAt}
    //         </Moment>,
    //         <CheckIcon key={4} checked={userData.archived} />,
    //         <CheckIcon key={5} checked={userData.deleted} />,
    //         <CheckIcon key={6} checked={userData.hasPassword} />,
    //       ];
    //     }}
    //     filters={
    //       <>
    //         <ResourceList.Filter
    //           name="searchQuery"
    //           defaultValue=""
    //           placeholder="Name or email"
    //         />
    //         {/* <ResourceList.Filter
    //           name="archived"
    //           defaultValue={'showActive'}
    //           options={[
    //             {
    //               label: 'Show active users',
    //               value: 'showActive',
    //             },
    //             {
    //               label: 'Hide active users',
    //               value: 'hideActive',
    //             },
    //             {
    //               label: 'Show active and inactive memberships',
    //               value: 'all',
    //             },
    //           ]}
    //         /> */}
    //         <ResourceList.Filter
    //           name="isAppAdmin"
    //           defaultValue={'all'}
    //           options={[
    //             {
    //               label: 'Show all users',
    //               value: 'all',
    //             },
    //             {
    //               label: 'Show admin users',
    //               value: 'showAdmins',
    //             },
    //             {
    //               label: 'Hide admin users',
    //               value: 'hideAdmins',
    //             },
    //           ]}
    //         />
    //         {/* <ResourceList.Filter
    //           name="deleted"
    //           defaultValue={'hideDeleted'}
    //           options={[
    //             {
    //               label: 'Hide deleted users',
    //               value: 'hideDeleted',
    //             },
    //             {
    //               label: 'Show deleted users',
    //               value: 'showDeleted',
    //             },
    //             {
    //               label: 'Show deleted and non-deleted users',
    //               value: 'all',
    //             },
    //           ]}
    //         /> */}
    //         <Button
    //           color="success"
    //           size="sm"
    //           className="ml-2"
    //           onClick={() => {
    //             toggleAddUserModal();
    //           }}
    //         >
    //           New user
    //         </Button>
    //         <AddUserModal
    //           isOpen={showAddUserModal}
    //           onClose={() => {
    //             toggleAddUserModal(false);
    //           }}
    //         />
    //       </>
    //     }
    //     headers={[
    //       {
    //         direction: 'ASC',
    //         label: 'Name',
    //         name: 'name',
    //         width: 20,
    //       },
    //       // {
    //       //   direction: 'ASC',
    //       //   label: 'Workspaces',
    //       //   name: 'workspaces',
    //       //   width: 20,
    //       // },
    //       {
    //         direction: 'ASC',
    //         label: 'Email',
    //         name: 'email',
    //         width: 30,
    //       },
    //       {
    //         direction: 'ASC',
    //         label: 'Created',
    //         name: 'createdAt',
    //         width: 20,
    //       },
    //       {
    //         direction: 'ASC',
    //         label: 'Updated',
    //         name: 'updatedAt',
    //         width: 20,
    //       },
    //       {
    //         direction: 'ASC',
    //         label: 'Active',
    //         name: 'active',
    //         width: 10,
    //       },
    //       {
    //         direction: 'ASC',
    //         label: 'Deleted',
    //         name: 'deleted',
    //         width: 10,
    //       },
    //       {
    //         direction: 'ASC',
    //         label: 'Created password',
    //         name: 'hasPassword',
    //         width: 10,
    //       },
    //     ]}
    //     query={users}
    //     keys={{
    //       count: 'usersCount',
    //       item: 'users',
    //     }}
    //     singular="user"
    //     plural="users"
    //   />
    // );
};
exports.default = exports.UsersList;
//# sourceMappingURL=UsersList.js.map